import { groups } from 'services/analytics/events/groups';
import { getAnalyticsClient } from 'services/apollo';
import {
  GroupsMetadataProps,
  GroupGetStartedNodeProps,
  GroupGetStartedActionProps,
} from 'services/analytics/events/propertyTypes';
import { GroupMemberFragment } from 'services/apollo/fragments';
import gql from 'graphql-tag';

interface TrackingData {
  groupId: string;
}

interface ActionTrackingData extends TrackingData {
  addedDocumentCount: number;
}

interface NodeTrackingData extends TrackingData {
  documentType: string;
}

export const TrackingGroupGetStartedFeedQuery = gql`
  query getGroupScreenGetStartedFeedAnalytics($groupId: String!) {
    groupById(id: $groupId) {
      id
      name
      groupType
      activityFeed {
        pageInfo {
          total
        }
      }
      ...groupMemberResults
    }
  }
  ${GroupMemberFragment}
`;

export const trackingGroupGetStartedFeed = (operation: any) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupGetStartedFeedQuery,
      variables: { groupId: operation.variables.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupsMetadataProps = {
      '[Group] Document count': response.data.groupById.activityFeed.pageInfo.total,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    return groups.page.viewGetStarted(metadata);
  });
};

export const trackGroupGetStartedSelectDocument = (data: NodeTrackingData) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupGetStartedFeedQuery,
      variables: { groupId: data.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupGetStartedNodeProps = {
      '[Metadata] Document type': data.documentType,
      '[Group] Document count': response.data.groupById.activityFeed.pageInfo.total,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    return groups.getStarted.select(metadata);
  });
};

export const trackGroupGetStartedAddSelectDocument = (data: ActionTrackingData) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupGetStartedFeedQuery,
      variables: { groupId: data.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupGetStartedActionProps = {
      '[Groups] [Get Started] Count Documents Added': data.addedDocumentCount,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    return groups.getStarted.add(metadata);
  });
};

export const trackGroupGetStartedSkip = (data: TrackingData) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupGetStartedFeedQuery,
      variables: { groupId: data.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupsMetadataProps = {
      '[Group] Document count': response.data.groupById.activityFeed.pageInfo.total,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    return groups.getStarted.skip(metadata);
  });
};

export const trackGroupGetStartedComplete = (data: ActionTrackingData) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupGetStartedFeedQuery,
      variables: { groupId: data.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupGetStartedActionProps = {
      '[Groups] [Get Started] Count Documents Added': data.addedDocumentCount,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    return groups.getStarted.complete(metadata);
  });
};
